<template>
    <div class="l-body">
        <div class="l-menu" @click="taskEvent(taskFlag)">战报上传
        </div>
        <div class="l-red" v-if="isRead"></div>
        <LTask :options="taskFlag" :list="listData" @closeTask="taskEvent(taskFlag)" />
    </div>
</template>
<script>
import LTask from "./components/l-task/l-task";
import TaskModel from './../models/task'
const taskModel = new TaskModel()
export default {
    name: "work",
    components: {
        LTask,
    },
    data() {
        return {
            taskFlag: false,
            listData: [],
            isRead: false
        };
    },
    mounted() {
        this.handleGetList()
    },
    methods: {
        taskEvent() {
            this.taskFlag = !this.taskFlag;

        },
        handleGetList() {
            taskModel.getElementList().then(res => {
                this.listData = res.data;
                this.listData.forEach(element => {
                    if (element.battleStatus===3&&element.showRead === 0) {
                        this.isRead = true;
                        return
                    }
                });
            })

        }
    },
};
</script>
<style lang="stylus" scoped>
@import url('./css/index.styl');
</style>
